import styled from 'styled-components'

export const Container = styled.div`
  border: 1px solid #dcdcdc;
  border-radius: 2px;
  padding: 20px;
  margin-bottom: 20px;
`
